<template>
  <div :id="echarts" ref="LineChart" class="container" />
</template>

<script>
import * as echarts from 'echarts'
import { EleResize } from '@/utils/eleResize'

export default {
  name: 'LineChart',
  props: {
    // 接收父组件传递过来的信息
    xData: {
      type: Array,
      default: () => []
    },
    yData: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {}
  },
  computed: {
    echarts () {
      return 'echarts' + Math.random() * 100000
    }
  },
  mounted: function () {
    const vm = this
    vm.$nextTick(() => {
      vm.drawChart()
    })
  },
  created: () => {},
  methods: {
    drawChart () {
      var myChart = echarts.init(document.getElementById(this.echarts))
      var option = {
        tooltip: {
          trigger: 'axis',
          backgroundColor: 'rgb(113,200,255, 0.28)',
          borderWidth: 0,
          textStyle: {
            fontSize: 15,
            color: '#fff'
          },
          axisPointer: { // 提示框指示线
            type: 'line',
            lineStyle: {
              color: '#fff'
            }
          },
          formatter (params) {
            return `<div style="font-size:18px;">${params[0].axisValue}</div>
              <div style="font-size:16px;margin-top:9px;">${params[0].value}条</div>`
          }
        },
        grid: {
          top: '12%',
          left: '4%',
          right: '6%',
          bottom: '4%',
          containLabel: true
        },
        xAxis: {
          type: 'category',
          boundaryGap: false,           
          data: this.xData,
          axisLabel: {
            color: '#B3B9BB '
          },
          splitLine: { show: false },
          axisLine: {
            show: false,
            lineStyle: {
              color: '#2F83C9'
            }
          },
          axisTick: { show: false }
        },
        yAxis: {
          type: 'value',
          nameTextStyle: {
            color: '#B3B9BB' // y轴 名字颜色
          },
          splitLine: {
            show: true,
            lineStyle: {
              // 设置背景横线
              color: '#525F65 '
            }
          },
          axisLabel: {
            color: '#fff',
          },
          axisLine: {
            show: false,
            lineStyle: {
              color: '#2F83C9'
            }
          },
          axisTick: { show: false },
          nameGap: 35
        },
        series: [{
          data: this.yData,
          type: 'line',
          smooth: true,
          itemStyle: {
            color: '#2FD0FF', // 改变折线点的颜色
            lineStyle: {
              color: 'rgba(47, 208, 255, 1)' // 改变折线颜色
            }
          },
          areaStyle: {
            color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
              {
                offset: 0,
                color: 'rgba(47, 208, 255, 1)' // 0% 处的颜色
              },
              {
                offset: 1,
                color: 'rgba(47, 208, 255, 0)' // 100% 处的颜色
              }
            ])
          }
        }]
      }
      option && myChart.setOption(option)
      const listener = function () {
        myChart.resize()
      }
      EleResize.on(document.getElementById(this.echarts), listener)
    }
  }
}
</script>

<style lang="scss" scoped>
.container {
  width: 100%;
  height: 100%;
}
</style>
